:root {
  color-scheme: light;
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  line-height: 1.45;
  font-weight: 400;
  color: #173333;
  background: #eef4f4;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

* { box-sizing: border-box; }
html, body, #root { margin: 0; height: 100%; }
button, input, select { font: inherit; }
a { color: #0d4f4f; }
